import React from 'react';
import cx from 'clsx';
import { Grid } from 'src/components/Grid';
import * as css from './Main.module.scss';

export function Main({ padded, ...props }: { children: ReactNode; padded?: boolean }) {
    return <Grid className={cx(css.main, padded && css.padded)} {...props} />;
}
